/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const DELETE_DISPLAY = gql`
  mutation DeleteDisplay($data: DeleteDisplayInput!) {
    deleteDisplay(data: $data) {
      id
      name
    }
  }
`
